import { AppThunk } from '../../../../storage/store';
import { fetchStart, fetchSuccess, fetchFailed } from './slice';
import { fetchStationListAPI } from './api';
import { getToken } from '../../../../utils/auth';

export const getStationList = (ownerId?: number): AppThunk => async (dispatch) => {
  const key = ownerId !== undefined ? String(ownerId) : 'all';
  dispatch(fetchStart());
  try {
    const token = getToken() || '';
    const response = await fetchStationListAPI(token, ownerId);
    dispatch(fetchSuccess({ key, stations: response.data?.chargingStations ?? [] }));
  } catch (err: any) {
    dispatch(fetchFailed(err?.message || 'Failed to load station list.'));
  }
};
